import { getTimeWithTimeZone } from 'utility/general';
import API from './index';

const api = {
    getConsolidationDetail({ documentType, docId }) {
        return API.authAPI({
            url: `/consolidation/load-page/${documentType}/${docId}`,
            method: 'GET',
            params: {},
        });
    },
    saveConsolidationDetail(data) {
        return API.authAPI({
            url: '/consolidation/save',
            method: 'POST',
            data,
        });
    },
    submitConsolidationDetail(data) {
        return API.authAPI({
            url: '/consolidation/confirm',
            method: 'POST',
            data,
        });
    },
    generateApprovalLetter(data) {
        const { decision, refNo, decisionDate } = data;

        return API.authAPI({
            url: `/generate/generate-approval-letter/${data.docType}/${data.docId}`,
            method: 'GET',
            params: {
                decision,
                refNo,
                decisionDate: decisionDate ? getTimeWithTimeZone(decisionDate).format('YYYY-MM-DD') : '-',
            },
            responseType: 'blob',
        });
    },
    downloadApprovalLetter(data) {
        return API.authAPI({
            url: `/consolidation/download-approval-letter/${data.docType}/${data.docId}`,
            method: 'GET',
            params: {},
            responseType: 'blob',
        });
    },
};

export default api;
